<template>
  <p>Git Hash: {{ gitHash }}</p>
</template>
<script>
export default {
  data() {
    return {
      gitHash: process.env.VUE_APP_GITVERSION
    };
  }
};
</script>
<style scoped>
p {
  padding: 1em;
  margin: 0;
  font-weight: bold;
}
</style>
